import WysiwygEditor from '../common/wysiwyg_editor';

class QuestionnaireWysiwygEditor extends WysiwygEditor {

  active = false;

  constructor($element, $scope) {
    super($element[0]);
    this.$scope = $scope;
  }

  $onInit() {
  }

  $onDestroy() {
    if (this.active) {
      this.removeEditor();
      this.active = false;
    }
  }

  get cssClasses() {
    let classes = [ 'wysiwyg', 'styled-content' ];
    if (this.active) classes.push('active');
    return classes;
  }

  edit() {
    if (!this.active) {
      this.active = true;
      this.initEditor();
    }
  }

  save() {
    this.value = this.editor.getContent();
    this.onSave({value: this.value}).then(() => {
      this.removeEditor();
      this.active = false;
      this.$scope.$digest();
    }).catch(e => {
      console.log("Error thrown", e);
    });
  }

  cancel() {
    this.editor.setContent(this.value);
    this.removeEditor();
    this.active = false;
  }

  prepareEditor(editor) {
    this.editor.focus();
  }

}

export default {
  name: 'questionnaireWysiwygEditor',
  obj: {
    controller: QuestionnaireWysiwygEditor,
    templateUrl: 'components/questionnaire_wysiwyg_editor.html',
    bindings: {
      value: '=',
      onSave: '&'
    }
  }
}